export const GET_OFFER_LIST_REQUEST = "get_offer_list_request";
export const GET_OFFER_LIST_RESPONSE = "get_offer_list_response";

export const ADD_OFFER_REQUEST = "add_offer_request";
export const ADD_OFFER_RESPONSE = "add_offer_response";

export const UPDATE_OFFER_BY_OFFER_ID_REQUEST =
  "update_offer_by_offer_id_request";
export const UPDATE_OFFER_BY_OFFER_ID_RESPONSE =
  "update_offer_by_offer_id_response";

export const DELETE_OFFER_BY_OFFER_ID_REQUEST =
  "delete_offer_by_offer_id_request";
export const DELETE_OFFER_BY_OFFER_ID_RESPONSE =
  "delete_offer_by_offer_id_response";

export const UPDATE_OFFER_STATUS_BY_OFFER_ID_REQUEST =
  "update_offer_status_by_offer_id_request";
export const UPDATE_OFFER_STATUS_BY_OFFER_ID_RESPONSE =
  "update_offer_status_by_offer_id_response";
